import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "pathitems"
    }}>{`PathItems`}</h1>
    <p>{`The collection of `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}>{`PathItem`}</a>{` objects in a document.`}</p>
    <p>{`Access through the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#pathitems"
      }}>{`Document.pathItems`}</a>{` collection property. To create new paths,
see `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathpointinfo/"
      }}>{`PathPointInfo`}</a>{` and `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/"
      }}>{`SubPathInfo`}</a>{` classes and pass them to `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitems/#add"
      }}>{`PathItems.add`}</a>{`() method.`}</p>
    <p><em parentName="p">{`Added in Photoshop 23.3`}</em></p>
    <h2 {...{
      "id": "indexable"
    }}>{`Indexable`}</h2>
    <p>{`▪ `}{`[index: `}<em parentName="p">{`number`}</em>{`]`}{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}><em parentName="a">{`PathItem`}</em></a></p>
    <p>{`Used to access the guides in the collection`}</p>
    <p>{`Access through the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/document/#pathitems"
      }}>{`Document.pathItems`}</a>{` collection property. To create new paths,
see `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathpointinfo/"
      }}>{`PathPointInfo`}</a>{` and `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/"
      }}>{`SubPathInfo`}</a>{` classes and pass them to `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitems/#add"
      }}>{`PathItems.add`}</a>{`() method.`}</p>
    <p><em parentName="p">{`Added in Photoshop 23.3`}</em></p>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`length`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/pathitem/"
            }}>{`PathItem`}</a>{` objects in this collection`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`parent`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Document`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The owner document of this PathItem collection`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "add"
    }}>{`add`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}><em parentName="a">{`PathItem`}</em></a></p>
    <p>{`Creates a new path item object and adds it to this collection.`}</p>
    <p>{`A new `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
      }}>{`SubPathItem`}</a>{` object is created for each `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/"
      }}>{`SubPathInfo`}</a>{` object provided in `}<inlineCode parentName="p">{`entirePath`}</inlineCode>{`,
and those `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
      }}>{`SubPathItem`}</a>{` objects are added to the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/#subpathitems"
      }}>{`PathItem.subPathItems`}</a>{` collection of the returned
`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}>{`PathItem`}</a>{`.`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`entirePath`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/classes/subpathinfo/"
            }}><em parentName="a">{`SubPathInfo`}</em></a>{`[]`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "getbyname"
    }}>{`getByName`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}><em parentName="a">{`PathItem`}</em></a></p>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3 {...{
      "id": "removeall"
    }}>{`removeAll`}</h3>
    <p><em parentName="p">{`void`}</em></p>
    <p>{`Clears all guides from this collection`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      